// extracted by mini-css-extract-plugin
export default {"container":"tournamentSettings_container__3rJcL","linksWrapper":"tournamentSettings_linksWrapper__Ptcrx","linkWrapper":"tournamentSettings_linkWrapper__-EThl"};